import { PermissionService } from './../../../service/permission.service';
import { OpportunityReportsStoreModels } from './../../../modules/shared/stores/opportunityReportsDataStore/opportunityReportsData.state';
import { OpportunityReportsRequestAction, OpportunityReportsSuccessAction } from './../../../modules/shared/stores/opportunityReportsDataStore/opportunityReportsData.actions';
import { selectorOpportunityReportsAllData } from './../../../modules/shared/stores/opportunityReportsDataStore/opportunityReportsData.selectors';
import { RootReducerState } from './../../../modules/shared/stores/ngrx.imports';
import { Store } from '@ngrx/store';
import { DATE_RANGE_LIST } from './../../../modules/shared/constants/date-range-list.constants';
import { ReportsAllFiltersAppyModels, ReportsAllFiltersApplyModes, typeReportsAllFiltersApplyModes } from './../../models/reports-all-filter-appy.models';
import { OpportunityReportsFiltersModels } from './../../../models/opportunity-reports/opportunity-reports-filters.models';
import { PercentageSymbolPipe } from './../../../modules/shared/pipes/percentage-symbol.pipe';
import { CurrencySymbolPipe } from './../../../modules/shared/pipes/currency-symbol.pipe';
import { ReportsPrintPdfService } from './../../servies/reports-print-pdf.service';
import { SecsToDhmsPipe } from './../../../modules/shared/pipes/secsToDhms.pipe';
import { ParseHelper } from './../../../modules/shared/parse.helper';
import { takeUntil } from 'rxjs/operators';
import { IReportsDataServiceTopMenuModel, ReportsDataServiceModelValues, ReportsTopMenuItemsValues, IReportsDataServiceLeftMenuExpantionModel } from './../../models/reports-data-service-model';
import { DataService } from './../../dataService';
import { LocalDatePipe } from './../../../shared/pipes/local-date.pipe';
import { myFavListData } from './../../myfav-data';
import { ReportsMyFavList } from './../../models/reports-myfav-list.model';
import { IReportsFilterModel } from './../../models/reports-filter.models';
import { ReportsOpportunityPermissions, ReportsOpportunityRoutes, ReportsOpportunityTypes } from './../../models/reports-opportunity.enums';
import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { CellDef } from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { Subscription, Subject } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ReportService } from '../../reportService';
import { IReportsColumnModel } from '../../models/reports.models';
import { getOpportunityReportsStoredData } from 'src/app/modules/shared/stores/opportunityReportsDataStore/opportunityReportsData.compare';

@Component({
    selector: 'app-reports-opportunity',
    templateUrl: './reports-opportunity.component.html',
    styleUrls: ['./reports-opportunity.component.scss'],
    providers: [SecsToDhmsPipe, CurrencySymbolPipe, PercentageSymbolPipe]
})
export class ReportsOpportunityComponent implements OnInit, OnDestroy, OnChanges {

    subscription: Subscription = new Subscription();

    //#region Properties
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    @Input() selectedReportFilters: OpportunityReportsFiltersModels;
    @Input() reloadContent: boolean = false;
    @Output() onReloadContent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLastReloadTime: EventEmitter<any> = new EventEmitter<Date>();
    @Input() selectedWindow: string = '';
    @Input() dashboardView: string = "";

    public reportName: string = '';
    @Input() dateFrom: any;
    @Input() dateTo: any;
    public selectedRepFilter = { name: "All", userName: "All", id: 0 };
    public selectedOppStageFilter = { name: "All", id: 0 };
    public selectedDateQuestionChannelfilter = { name: "All", id: 0 };
    public selectedDateCasesChannelfilter = { name: "All", id: 0 };
    public selectedDatePipelineFilter = { name: "All", id: 0 };
    public reportsFilterApplyMode: typeReportsAllFiltersApplyModes|"" = "";

    public reportDate: any;
    public selectedDateFilter: any = null;
    public selectedFilterGroup: IReportsFilterModel[] = [];
    private myFavId: number = 0;
    private myFavList: ReportsMyFavList[] = myFavListData as any;
    private selectedMyFav: ReportsMyFavList = null;

    opportunityChannelListData = [];
    accountsChannelList = [];
    leadsChannelList = [];
    allAcountChannel = {
        id: 0,
        name: "All Account Channels"
    };

    showChannelFilter: boolean = false;
    channelList = [];
    selectedChannel = null;

    showOpportunityChannelFilter: boolean = false;
    opportunityChannelList = [];
    selectedOpportunityChannel = null;

    reportsDataLoaded: boolean = false;

    @Input() displayFilterPopup: boolean = false;
    filterPopupHeader: string = "Filter";
    loadReportsFirstTime: boolean = false;
    opportunityReportsLoading: boolean = false;
    @Output() onCloseFilterPopup: EventEmitter<any> = new EventEmitter<any>();
    @Output() onUpdateAllFilters: EventEmitter<ReportsAllFiltersAppyModels> = new EventEmitter<ReportsAllFiltersAppyModels>();

    first = 0;
    showRows = 15;
    public pageSize = 15;
    public pageNumber = 0;
    public Months: any[] = [];
    public cols: IReportsColumnModel[] = [];
    public tableCols: IReportsColumnModel[] = [];
    public groupByFieldName = "";
    public reportsData = [];
    public reportsDataCopy = [];
    public openOpportunityOwnerdata = [];
    public filterByInputValue: any[] = [];// available value pass to filter component
    public reportsFlatData = [];// available value pass to table component
    public totalRecords: number = 0;
    public totalPages: number;
    public noContactFindOrLoadingText = 'Loading....';
    public organizationName = "";

    public chartLabel;
    public stackedBar: any;
    public stackedOptions: any;
    public barData: any;
    public basicOptions: any;


    public stackedBarByClosedWon: any = null;
    public closedWonStackedOptions;

    public stackedBarByClosedWonCount: any = null;
    public closedWonCountStackedOptions;

    public stageSummeryBar = null;
    public stageBarbasicOptions;


    public stageDetailsBar = null;
    public stageDetailsBarOptions;

    totalRevenue: Number;
    totalAmount: Number;
    chartLabel1;
    chartLabel2;
    stackedBar1: any;
    stackedBar2: any;
    performanceStackBarAmount: any;
    performanceStackBarPercentage: any;
    stackedOptions1;
    stackedOptions2;
    noData = "No Reports Available."
    //#endregion
    constructor(
        private store: Store<RootReducerState>,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private dataService: DataService,
        private secsToDhmsPipe: SecsToDhmsPipe,
        public localDatePipe: LocalDatePipe,
        private currencySymbolPipe: CurrencySymbolPipe,
        private percentageSymbolPipe: PercentageSymbolPipe,
        private permissionService: PermissionService
    ) {
        this.dataService.getData<IReportsDataServiceTopMenuModel>().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(data => {
            if (data.actionType == ReportsDataServiceModelValues.reportsTopMenuItems) {
                if (data.value == ReportsTopMenuItemsValues.print) {
                    this.print();
                }
                else if (data.value == ReportsTopMenuItemsValues.PDF) {
                    this.exportPDF(this.selectedWindow, false);
                }
                else if (data.value == ReportsTopMenuItemsValues.XLS) {
                    this.exportXLS(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.XLSX) {
                    this.exportXLSX(this.selectedWindow)
                }
                else if (data.value == ReportsTopMenuItemsValues.Refresh) {
                    this.selectedFilterGroup = [];
                    this.OpportunityReport();
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges){
        if(changes?.selectedWindow?.currentValue){
            this.selectedWindow = changes.selectedWindow.currentValue;
            if(this.loadReportsFirstTime) this.loadChartDataOnly();
        }

        if(changes?.displayFilterPopup){
            this.displayFilterPopup = changes.displayFilterPopup?.currentValue||false;
        }

        if(changes?.reloadContent && changes?.reloadContent?.currentValue){
            this.reloadContent = true;
            this.loadReportsFirstTime = true;
            this.loadChartDataOnly();
        }

        if(changes?.selectedReportFilters && changes?.selectedReportFilters?.currentValue){
            this.selectedReportFilters = changes?.selectedReportFilters?.currentValue;
            if(this.loadReportsFirstTime) this.setSelectedFilters();
        }
    }

    async ngOnInit(){
        !this.dashboardView && this.appMainService.isShowSpinner('channelLoader');
        this.opportunityReportsLoading = true;
        this.opportunityChannelListData = await this.dataService.getOpportunityChannelList();
        this.accountsChannelList = await this.dataService.getAccountChannelList();
        this.opportunityReportsLoading = false;
        this.appMainService.isHideSpinner('channelLoader');
        // this.leadsChannelList = await this.dataService.getLeadChannelList();

        if(this.dashboardView){
            this.loadReportsFirstTime = true;
            this.loadChartDataOnly();
        }else{
            this.subscription = this.router.paramMap.subscribe((param: any) => {
                const activityType = param.params.type;

                switch (activityType) {
                    case ReportsOpportunityRoutes.closedwonopportunitysummary:
                        this.selectedWindow = ReportsOpportunityTypes.closedwonopportunitysummary;
                        break;
                    case ReportsOpportunityRoutes.closedwonopportunitydetail:
                        this.selectedWindow = ReportsOpportunityTypes.closedwonopportunitydetail;
                        break;
                    case ReportsOpportunityRoutes.openopportunitybyowner:
                        this.selectedWindow = ReportsOpportunityTypes.openopportunitybyowner;
                        break;
                    case ReportsOpportunityRoutes.opportunitybycloseddatestagesummary:
                        this.selectedWindow = ReportsOpportunityTypes.opportunitybycloseddatestagesummary;
                        break;
                    case ReportsOpportunityRoutes.opportunitybycloseddatestagedetail:
                        this.selectedWindow = ReportsOpportunityTypes.opportunitybycloseddatestagedetail;
                        break;
                    case ReportsOpportunityRoutes.performancebysales:
                        this.selectedWindow = ReportsOpportunityTypes.performancebysales;
                        break;
                    case ReportsOpportunityRoutes.opportunityqualitymetricssummary:
                        this.selectedWindow = ReportsOpportunityTypes.opportunityqualitymetricssummary;
                        break;
                    case ReportsOpportunityRoutes.opportunityqualitymetricsdetail:
                        this.selectedWindow = ReportsOpportunityTypes.opportunityqualitymetricsdetail;
                        break;
                    case ReportsOpportunityRoutes.opportunitypipelinesummary:
                        this.selectedWindow = ReportsOpportunityTypes.opportunitypipelinesummary;
                        break;
                    case ReportsOpportunityRoutes.opportunitypipelinedetail:
                        this.selectedWindow = ReportsOpportunityTypes.opportunitypipelinedetail;
                        break;
                    default:
                        break;
                }

                this.selectDefaultChannel();
                this.cols = [];//clear filter
                this.tableCols = [];
                this.groupByFieldName = "";
                this.selectedFilterGroup = [];

                this.OpportunityReport();
                //Send To Parent Component For Left Menu Expand
                this.dataService.sendData<IReportsDataServiceLeftMenuExpantionModel>({ actionType: ReportsDataServiceModelValues.reportsLeftMenuExpansion, value: this.selectedWindow });
            });
        }
    }

    loadChartDataOnly(){
        this.cols = [];//clear filter
        this.tableCols = [];
        this.groupByFieldName = "";
        this.selectedFilterGroup = [];

        this.setSelectedFilters();
        this.setAddedFilters();
        if(!this.selectedReportFilters?.dateFilter){
            this.OpportunityReport();
        }
    }

    setSelectedFilters(){
        this.selectDefaultChannel(this.selectedReportFilters?.opportunityChannelId||0,this.selectedReportFilters?.accountChannelId||0)

        if(this.selectedReportFilters?.dateFilter){
            this.selectedDateFilter = {
                label: this.selectedReportFilters.dateFilter,
                code: this.selectedReportFilters.dateFilter,
                fromDate: this.selectedReportFilters?.fromDate||null,
                toDate: this.selectedReportFilters?.toDate||null
            }
        }
    }

    selectDefaultChannel(opportunityChannel: number = 0, accountChannel: number = 0){
        this.showOpportunityChannelFilter = true;
        this.opportunityChannelList = this.opportunityChannelListData;

        const oppChannelExist = this.opportunityChannelList.find(channel=>channel?.id==opportunityChannel);

        if(oppChannelExist && opportunityChannel){
            this.selectedOpportunityChannel = oppChannelExist;
        }else{
            this.selectedOpportunityChannel = this.opportunityChannelList ? this.opportunityChannelList.find(el=>el.isDefault==true)||this.opportunityChannelList[0] : null;
        }

        this.showChannelFilter = true;
        this.channelList = this.permissionService.filterChannelsByReportPermissions(this.accountsChannelList, ReportsOpportunityPermissions[this.selectedWindow]);

        const accChannelExist = this.channelList.find(channel=>channel?.id==accountChannel);

       if(accChannelExist && accountChannel){
            this.selectedChannel = accChannelExist;
       }else{
            this.selectedChannel = this.channelList ? this.channelList.find(el=>el.isDefault==true)||this.channelList[0] : null;
       }
    }

    OpportunityReport() {

        const getReportsData = this.store.select(selectorOpportunityReportsAllData);

console.log("getReportsDataO",getReportsData)
        !this.dashboardView && this.appMainService.isShowSpinner('OpportunityReport');
        this.reportsData = [];
        this.organizationName = this.app.user.organizationName;
        this.reportsDataLoaded = false;
        this.opportunityReportsLoading = true;

        const addedFilters: OpportunityReportsFiltersModels = {
            dateFilter: this.selectedDateFilter?.code,
            fromDateOnly: this.formatDate(this.dateFrom),
            toDateOnly: this.formatDate(this.dateTo),
            opportunityChannelId: this.selectedOpportunityChannel?.id||0,
            accountChannelId: this.selectedChannel?.id||0
        }

        getReportsData.subscribe(storedData=>{
         console.log("storedDataO:",storedData)

            const results = getOpportunityReportsStoredData(storedData,this.selectedWindow,addedFilters);
            // console.log(results);
            if(results.index > -1 && this.dashboardView!='' && !this.reloadContent && this.reportsFilterApplyMode==""){
                const updatedTime: Date = results?.data?.loadedTime ? new Date( results?.data?.loadedTime) : new Date();
                this.onLastReloadTime.emit(updatedTime);
                this.setReportsResponse(results?.data?.reportsData||[]);
                this.setReportsFinalResponse();
            }else{
                this.reloadContent = false;
                this.loadNewReportsData(addedFilters);
            }

        });
    }

    loadNewReportsData(addedFilters: OpportunityReportsFiltersModels){
        if(this.dashboardView!='' && this.reportsFilterApplyMode!=ReportsAllFiltersApplyModes.applyOnly){
            this.store.dispatch(new OpportunityReportsRequestAction());
        }

        if(!this.selectedWindow || !addedFilters.accountChannelId) {
            return;
        }

        this.reportService.OpportunityReports(addedFilters.fromDateOnly,addedFilters.toDateOnly, this.selectedWindow, addedFilters.accountChannelId, addedFilters.opportunityChannelId).then(res => {
                let { contacts, headers } = res;
                contacts = contacts.length > 0 ? this.formatedData(contacts) : [];
                let results = ParseHelper.DeepCopy(contacts)||[];
                const updatedTime: Date = new Date();
                this.onLastReloadTime.emit(updatedTime);
                this.setReportsResponse(results);

                if(this.dashboardView!='' && this.reportsFilterApplyMode!=ReportsAllFiltersApplyModes.applyOnly){
                    this.setOpportunityStoreData(results,addedFilters);
                }

                this.reportsFilterApplyMode = "";

        }).finally(() => {
            this.setReportsFinalResponse();
        });
    }

    setReportsResponse(responseData){
        this.reportsData = responseData;
        this.reportsDataCopy = ParseHelper.DeepCopy(responseData);
        this.filterByInputValue = ParseHelper.DeepCopy(responseData);
        this.reportsDataLoaded = true;
        this.opportunityReportsLoading = false;
        this.appMainService.isHideSpinner('OpportunityReport');
    }

    setReportsFinalResponse(){
        //set filtered cols
        this.reportsDataLoaded = true;
        this.opportunityReportsLoading = false;
        this.setFilterCols();
        this.setCustomFilters();
        this.appMainService.isHideSpinner('OpportunityReport');
        this.noContactFindOrLoadingText = 'No Reports Available.';
        this.onReloadContent.emit(false);
    }

    setOpportunityStoreData(results: any, addedFilters: OpportunityReportsFiltersModels){
        const reportsData: OpportunityReportsStoreModels = {
            reportsData: results,
            reportType: this.selectedWindow,
            loadedTime: new Date(),
            addedFilters: addedFilters,
            loading: false,
            loaded: true
        }

        this.store.dispatch(new OpportunityReportsSuccessAction(reportsData));
    }

    formatedData(results){
        let dataResults = results;

        switch (this.selectedWindow) {
            case ReportsOpportunityTypes.closedwonopportunitydetail:
            case ReportsOpportunityTypes.closedwonopportunitysummary:   {
                dataResults = results.reverse().sort((a, b) => (a?.opportunityOwner > b?.opportunityOwner) ? 1 : -1);
                break;
            }
            case ReportsOpportunityTypes.opportunitybycloseddatestagedetail: {
                //dataResults = results.reverse().sort((a, b) => (a?.opportunityStageId > b?.opportunityStageId) ? 1 : -1);
                break;
            }
            case ReportsOpportunityTypes.openopportunitybyowner: {
                dataResults = results.reverse().sort((a, b) => (a?.opportunityOwner > b?.opportunityOwner) ? 1 : -1);
                break;
            }
            case ReportsOpportunityTypes.performancebysales: {
                dataResults = this.formatSalesPerformanceData(results);
                break;
            }
            case ReportsOpportunityTypes.opportunitypipelinedetail: {
                dataResults = results.reverse().sort((a, b) => a.accountname.localeCompare(b.accountname))
                break;
            }
            case ReportsOpportunityTypes.opportunitypipelinesummary: {
                dataResults = results.reverse().sort((a, b) => a.account.localeCompare(b.account))
                break;
            }
            default: {
                break;
            }
        }

        return dataResults;
    }

     //#region *******Filter Logic******

    setFilterCols(): void {
        this.filterByInputValue = [];
        switch (this.selectedWindow) {
            case ReportsOpportunityTypes.closedwonopportunitysummary: {
                this.tableCols = [
                    { id: 1, field: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string" },
                    { id: 2, field: 'totalOpportunity', header: 'Total Opportunity', dataType: "string" },
                    { id: 3, field: 'grandTotal', header: 'Grand Total', dataType: "currencySymbol" }
                ];
                this.cols = this.tableCols;
                this.reportName = 'Closed Won Summary';
                break;
            }
            case ReportsOpportunityTypes.closedwonopportunitydetail: {
                this.tableCols = [
                    { id: 1, field: 'opportunityOwnerEmail', groupField: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string", isShow: true },
                    { id: 2, field: 'opportunityName', header: 'Opportunity Name', dataType: "string", isShow: true },
                    { id: 3, field: 'account', header: 'Account', dataType: "string", isShow: true },
                    { id: 4, field: 'className', header: 'Acct. Class', dataType: "string", isShow: true },
                    { id: 5, field: 'createDate', header: 'Create Date', dataType: "date", isShow: true },
                    { id: 6, field: 'wonDate', header: 'Won Date', dataType: "date", isShow: true },
                    { id: 7, field: 'closedWonAmount', groupField: 'totalClosedWonAmount', groupType: 'sum', header: 'Won Amount', dataType: "currencySymbol", isShow: true },
                    { id: 8, field: 'createAmount', groupField: 'totalCreateAmount',  groupType: 'sum', header: 'Create Amount', dataType: "currencySymbol", isShow: true },
                    { id: 9, field: 'variation', header: 'Var. Amount',groupField: 'totalVariation',  groupType: 'sum', dataType: "currencySymbol", isShow: true },
                    { id: 10, field: 'variationperc', header: 'Var. %', groupField: 'totalVariationperc',  groupType: 'variationPercentage', dataType: "string", isShow: true },
                ];
                this.cols = [
                    { id: 1, field: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string", isShow: true },
                    { id: 2, field: 'opportunityName', header: 'Opportunity Name', dataType: "string", isShow: true },
                    { id: 3, field: 'account', header: 'Account', dataType: "string", isShow: true },
                    { id: 4, field: 'className', header: 'Acct. Class', dataType: "string", isShow: true },
                    { id: 5, field: 'createDate', header: 'Create Date', dataType: "date", isShow: true},
                    { id: 6, field: 'wonDate', header: 'Won Date', dataType: "date", isShow: true },
                    { id: 7, field: 'closedWonAmount', header: 'Won Amount', dataType: "string", isShow: true },
                    { id: 8, field: 'createAmount', header: 'Create Amount', dataType: "string", isShow: true },
                    { id: 9, field: 'variation', header: 'Var. Amount', dataType: "string", isShow: true },
                    { id: 10, field: 'variationperc', header: 'Var. %', dataType: "string", isShow: true },
                ];;

                this.reportName = 'Closed Won By Owner';
                this.chartLabel = `Opportunity Won (${this.currencySymbolPipe.transform('')})`;
                this.chartLabel2 = 'Opportunity Won Count';
                this.groupByFieldName = "opportunityOwner";

                const globalThis = this;
                this.closedWonStackedOptions = {
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    responsive: true,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += globalThis.currencySymbolPipe.transform(context.parsed.y,'number2dp');
                                    }
                                    return label;
                                }
                            }
                        },
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };

                this.closedWonCountStackedOptions = {
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    responsive: true,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += `${context.parsed.y} Opportunity`;
                                    }
                                    return label;
                                }
                            }
                        },
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };
                break;
            }
            case ReportsOpportunityTypes.openopportunitybyowner: {
                this.tableCols = [
                    { id: 1, field: 'opportunityOwnerEmail', groupField: 'opportunityOwner', header: 'Owner', dataType: "string" },
                    { id: 2, field: 'account', header: 'Account', dataType: "string" },
                    { id: 3, field: 'closingDate', header: 'Closing Date', dataType: "date" },
                    { id: 4, field: 'probability', header: 'Probability', dataType: "percentageSymbol" },
                    { id: 5, field: 'est_Revenue',groupField: 'totalest_Revenue', groupType: 'sum', header: 'Est Revenue', dataType: "currencySymbol" },
                    { id: 6, field: 'weighted_Amt', groupField: 'totalweighted_Amt', groupType: 'sum', header: 'Weighted Amt', dataType: "currencySymbol" },
                    { id: 7, field: 'last_Updated', header: 'Last Updated', dataType: "date" },
                    { id: 8, field: 'createDate', header: 'Created Date', dataType: "date" },
                    { id: 9, field: 'no_day_Pipeline', header: '# of Days in Pipeline', dataType: "string" },
                ];

                this.cols =  [
                    { id: 1, field: 'opportunityOwner', header: 'Owner', dataType: "string" },
                    { id: 2, field: 'account', header: 'Account', dataType: "string" },
                    { id: 3, field: 'closingDate', header: 'Closing Date', dataType: "date" },
                    { id: 4, field: 'probability', header: 'Probability', dataType: "percentageSymbol" },
                    { id: 5, field: 'est_Revenue', header: 'Est Revenue', dataType: "currencySymbol" },
                    { id: 6, field: 'weighted_Amt', header: 'Weighted Amt', dataType: "currencySymbol" },
                    { id: 7, field: 'last_Updated', header: 'Last Updated', dataType: "date" },
                    { id: 8, field: 'createDate', header: 'Created Date', dataType: "date" },
                    { id: 9, field: 'no_day_Pipeline', header: '# of Days in Pipeline', dataType: "string" },
                ];
                this.reportName = 'Open Opportunities by Owner';
                this.groupByFieldName = "opportunityOwner";
                break;
            }
            case ReportsOpportunityTypes.opportunitybycloseddatestagesummary: {
                this.tableCols = [
                    { id: 1, field: 'opportunityStage', header: 'Opportunity Stage', dataType: "string" },
                    { id: 2, field: 'totalOpportunity', header: 'Total Opportunity', dataType: "string" },
                    { id: 3, field: 'grandTotal', header: 'Stage Total', dataType: "currencySymbol" }
                ];

                this.cols = this.tableCols;
                this.reportName = 'Opportunity by Stage Summary';
                this.chartLabel = `Stage Total (${this.currencySymbolPipe.transform('')})`;

                const globalThis = this;
                this.stageBarbasicOptions = {
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += globalThis.currencySymbolPipe.transform(context.parsed.y,'number2dp');
                                    }
                                    return label;
                                }
                            }
                        },
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };
                break;
            }
            case ReportsOpportunityTypes.opportunitybycloseddatestagedetail: {
                this.tableCols = [
                    { id: 1, field: 'opportunityStageIds',  groupField: 'opportunityStage', header: 'Opportunity Stage', dataType: "string", isShow: true },
                    { id: 2, field: 'opportunityName', header: 'Opportunity Name', dataType: "string", isShow: true },
                    { id: 3, field: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string", isShow: true },
                    { id: 4, field: 'account', header: 'Account', dataType: "string", isShow: true },
                    { id: 5, field: 'createDate', header: 'Created Date', dataType: "date", isShow: true },
                    { id: 6, field: 'closedDate', header: 'Close Date', dataType: "date", isShow: true },
                    { id: 7, field: 'totalAmount', groupField: 'totalSumAmount',  groupType: 'sum', header: 'Amount', dataType: "currencySymbol", isShow: true },
                ];

                this.cols = [
                    { id: 1, field: 'opportunityStage', header: 'Opportunity Stage', dataType: "string", isShow: true },
                    { id: 2, field: 'opportunityName', header: 'Opportunity Name', dataType: "string", isShow: true },
                    { id: 3, field: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string", isShow: true },
                    { id: 4, field: 'account', header: 'Account', dataType: "string", isShow: true },
                    { id: 5, field: 'createDate', header: 'Created Date', dataType: "date", isShow: true },
                    { id: 6, field: 'closedDate', header: 'Close Date', dataType: "date", isShow: true},
                    { id: 7, field: 'totalAmount', header: 'Amount', dataType: "string", isShow: true },
                ];;

                this.reportName = 'Opportunity by Stage Details';
                this.chartLabel = `Opportunity Stage Total (${this.currencySymbolPipe.transform('')})`;
                this.groupByFieldName = "opportunityStage";

                const globalThis = this;
                this.stageDetailsBarOptions = {
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    },
                    responsive: true,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += globalThis.currencySymbolPipe.transform(context.parsed.y,'number2dp');
                                    }
                                    return label;
                                }
                            }
                        },
                        legend: {
                            labels: {
                                color: '#495057'
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };

                break;
            }
            case ReportsOpportunityTypes.opportunityqualitymetricsdetail: {
                this.tableCols = [
                    { id: 1, field: 'opportunityName', header: 'Opportunity Name', dataType: "string" },
                    { id: 2, field: 'noOfDaysOpen', header: 'No. Of Days Open', dataType: "string" },
                    { id: 3, field: 'noOfDaysSinceLastStageChange', header: 'No. Of Days Since Last Stage Change', dataType: "string" },
                    { id: 4, field: 'noOfCloseDateExtension', header: 'No. Of Close Date Extension', dataType: "string" },
                    { id: 5, field: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string" },
                    { id: 6, field: 'accountName', header: 'Account Name', dataType: "string" },
                    { id: 7, field: 'stage', header: 'Stage', dataType: "string" },
                    { id: 8, field: 'amount', header: 'Amount', dataType: "currencySymbol" },
                ];

                this.cols = this.tableCols;

                this.reportName = 'Opportunity Quality Metrics Details';

                break;
            }
            case ReportsOpportunityTypes.performancebysales: {
                this.tableCols = [
                    { id: 1, field: 'salesPerson', header: 'Sales Person', dataType: "string" },
                    { id: 2, field: 'accountName', header: 'Account', dataType: "string" },
                    { id: 3, field: 'statusName', header: 'Status', dataType: "string" },
                    { id: 4, field: 'wonPerc', header: 'Won', dataType: "percentageSymbol" },
                    { id: 5, field: 'lostPerc', header: 'Lost', dataType: "percentageSymbol" },
                    { id: 6, field: 'totalOpen', header: 'Open', dataType: "string" },
                    { id: 7, field: 'totalAll', header: 'Total', dataType: "string" },
                ];

                this.cols =  this.tableCols;

                this.reportName = 'Opportunity Performance by Sales Person';
                this.chartLabel1 = `${this.currencySymbolPipe.transform('')} of Opportunities Won and Lost`;
                this.chartLabel2 = "% of Opportunities Won and Lost";
                this.stackedBar1 = {
                    labels: ['Gina Malik', 'Sam', 'Anish', 'John', 'Lisa', 'Josh', 'Max'],
                    datasets: [{
                        type: 'bar',
                        label: 'Won',
                        backgroundColor: '#66BB6A',
                        data: [
                            21,
                            84,
                            24,
                            75,
                            37,
                            65,
                            34
                        ]
                    }, {
                        type: 'bar',
                        label: 'Lost',
                        backgroundColor: '#df3f2a',
                        data: [
                            41,
                            52,
                            24,
                            74,
                            23,
                            21,
                            32
                        ]
                    }]
                };
                this.stackedBar2 = {
                    labels: ['Gina Malik', 'Sam', 'Anish', 'John', 'Lisa', 'Josh', 'Max'],
                    datasets: [{
                        type: 'bar',
                        label: 'Won',
                        backgroundColor: '#66BB6A',
                        data: [
                            21,
                            25,
                            24,
                            45,
                            37,
                            65,
                            34
                        ]
                    }, {
                        type: 'bar',
                        label: 'Lost',
                        backgroundColor: '#df3f2a',
                        data: [
                            41,
                            52,
                            24,
                            24,
                            23,
                            31,
                            32
                        ]
                    }]
                };

                const globalThis = this;
                this.stackedOptions1 = {
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += globalThis.currencySymbolPipe.transform(context.parsed.y,'number2dp');
                                    }
                                    return label;
                                }
                            }
                        },
                        legend: {
                            labels: {
                                color: '#495057',
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };
                this.stackedOptions2 = {
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += ': ';
                                    }
                                    if (context.parsed.y !== null) {
                                        label += context.parsed.y + '%';
                                    }
                                    return label;
                                }
                            }
                        },
                        legend: {
                            labels: {
                                color: '#495057',
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        },
                        y: {
                            stacked: true,
                            ticks: {
                                color: '#495057'
                            },
                            grid: {
                                color: '#ebedef'
                            }
                        }
                    }
                };
                break;
            }
            case ReportsOpportunityTypes.opportunityqualitymetricssummary: {
                this.tableCols = [
                    { id: 1, field: 'opportunityName', header: 'Opportunity Name', dataType: "string" },
                    { id: 2, field: 'noOfDaysOpen', header: 'No. Of Days Open', dataType: "string" },
                    { id: 3, field: 'noOfDaysSinceLastStageChange', header: 'No. Of Days Since Last Stage Change', dataType: "string" },
                    { id: 4, field: 'noOfCloseDateExtension', header: 'No. Of Close Date Extension', dataType: "string" },
                    { id: 5, field: 'opportunityOwner', header: 'Opportunity Owner', dataType: "string" },
                ];

                this.cols = this.tableCols;


                this.reportName = 'Opportunity Quality Metrics Summary';
                break;
            }
            case ReportsOpportunityTypes.opportunitypipelinedetail: {
                this.tableCols = [
                    { id: 1, field: 'accountname', header: 'Account Name', dataType: "string" },
                    { id: 2, field: 'accountowner', header: 'Account Owner', dataType: "string" },
                    { id: 3, field: 'grandTotal', header: 'Amount', dataType: "currencySymbol" }
                ];

                this.cols = this.tableCols;

                this.reportName = 'Open Pipeline Details';
                break;
            }
            case ReportsOpportunityTypes.opportunitypipelinesummary: {
                this.tableCols = [
                    { id: 1, field: 'account', header: 'Account', dataType: "string" },
                    { id: 2, field: 'amount', header: 'Grand Total', dataType: "currencySymbol" },
                ];
                this.cols = this.tableCols;

                this.reportName = 'Open Pipeline Summary';
                break;
            }

            default: {
                break;
            }
        }
        //set filter value
        this.setFilterValues();
    }

    setFilterValues(): void {
        this.filterByInputValue = [];
        this.setGroupSummationData();
        switch (this.selectedWindow) {
            case ReportsOpportunityTypes.opportunitybycloseddatestagesummary:
                this.filterByInputValue = [...this.reportsData];
                this.setStageSummeryChart();
                break;
            case ReportsOpportunityTypes.opportunitybycloseddatestagedetail:
                this.filterByInputValue = [...this.reportsData];
                this.setStageDetailsChart();
                break;

            case ReportsOpportunityTypes.closedwonopportunitydetail:
                this.filterByInputValue = [...this.reportsData];
                this.setClosedWonChart();
                this.setClosedWonCountChart();
                break;
            case ReportsOpportunityTypes.openopportunitybyowner:
                this.filterByInputValue = [...this.reportsData];
                this.formatOpenOpportunityOwnerData();
                break;
            case ReportsOpportunityTypes.performancebysales:
                this.reportsData = this.formatSalesPerformanceData(this.reportsData);
                this.filterByInputValue = [];

                this.reportsData.map(data=>{
                    data.status.map(status=>{
                        this.filterByInputValue.push({...data,...status});
                    });
                });
                this.setPerformanceCharts();
                break;
            default:
                this.filterByInputValue = [...this.reportsData];
                break;
        }
        this.reportsFlatData = ParseHelper.DeepCopy(this.filterByInputValue);
    }

    formatSalesPerformanceData(results){
        let dataResults = ParseHelper.DeepCopy(results);
        dataResults.map(data=>{

            data['totalAll'] = data.status?.length||0;
            data['totalAllAmount'] = data.status.reduce((sum, data) => data.amount + sum, 0);

            let lostStatus = data.status.filter(status=>status.closedLost);
            data['totalLost'] = lostStatus.length||0;
            data['totalLostAmount'] = lostStatus.reduce((sum, data) => data.amount + sum, 0);

            let openStatus = data.status.filter(status=>status.open);
            data['totalOpen'] = openStatus.length||0;
            data['totalOpenAmount'] = openStatus.reduce((sum, data) => data.amount + sum, 0);

            let wonStatus = data.status.filter(status=>status.closedWon);
            data['totalWon'] = wonStatus.length||0;
            data['totalWonAmount'] = wonStatus.reduce((sum, data) => data.amount + sum, 0);

            data['wonPerc'] = data['totalWon']>0 ? (data['totalWon'] / ( data['totalWon'] + data['totalLost']) * 100).toFixed(2) : 0;
            data['lostPerc'] = data['totalLost']> 0 ? (data['totalLost'] / ( data['totalWon'] + data['totalLost']) * 100).toFixed(2) : 0;

            data.status.map(status=>{
                if(status.open) status['statusName'] = "Open";
                if(status.closedWon) status['statusName'] = "Won";
                if(status.closedLost) status['statusName'] = "Lost";
            })

        });

        return dataResults;
    }

    formatOpenOpportunityOwnerData(){
        const groupData = this.groupByData(this.reportsData,'opportunityOwner');
        this.openOpportunityOwnerdata = [];

        groupData.map((data,index)=>{
            const netRevenue =  data.dataList ? data.dataList.reduce((sum, data) => data.est_Revenue + sum, 0) : 0;
            const netAmount =  data.dataList ? data.dataList.reduce((sum, data) => data.weighted_Amt + sum, 0) : 0;
            const totalDays =  data.dataList ? data.dataList.reduce((sum, data) => data.no_day_Pipeline + sum, 0) : 0;
            const avgDays = totalDays>0 ? (totalDays/data.dataList.length).toFixed(2) : 0;

            const rowData = {
                opportunityOwner: data.opportunityOwner,
                children: data.dataList,
                netRevenue: netRevenue,
                netAmount: netAmount,
                avgDays: avgDays
            }

            this.openOpportunityOwnerdata.push(rowData);
        });

        this.totalRevenue = this.reportsData ? this.reportsData.reduce((sum, data) => data.est_Revenue + sum, 0) : 0;
        this.totalAmount = this.reportsData ? this.reportsData.reduce((sum, data) => data.weighted_Amt + sum, 0) : 0;
    }

    setGroupSummationData(){
        const groupCols = this.tableCols.filter(col=> col?.groupType);

        if(groupCols.length>0 && this.groupByFieldName!=""){
            this.reportsData.map(rowData=>{
                const groupData = this.reportsData.filter(data=> data[this.groupByFieldName]==rowData[this.groupByFieldName]);
                groupCols.map(groupCol=>{
                    switch (groupCol.groupType) {
                        case 'sum':
                            rowData[groupCol.groupField] = groupData ? groupData.reduce((sum, data) => data[groupCol.field] + sum, 0) : 0;
                            break;
                         case 'variationPercentage':
                            if(this.selectedWindow==ReportsOpportunityTypes.closedwonopportunitydetail){
                                const startingValue =  groupData ? groupData.reduce((sum, data) => data['createAmount'] + sum, 0) : 0;
                                const finalValue = groupData ? groupData.reduce((sum, data) => data['closedWonAmount'] + sum, 0) : 0;
                                const variation = finalValue -  startingValue;
                                let variationPercentage = finalValue;

                                if(startingValue>0){
                                    variationPercentage = variation!=0 ? (variation/startingValue)*100 : 0;
                                }

                                rowData[groupCol.groupField] = `${variationPercentage.toFixed(2)}%`;
                            }
                            break;
                        default:
                            break;
                    }

                })
            });
        }
    }

    setCustomFilters(){
        const selectedFilters = this.myFavList.find(fav=>fav.id==this.myFavId);

        if(selectedFilters){
            this.selectedFilterGroup = [];

            this.appMainService.isShowSpinner('ReportFavFilters');
            selectedFilters.filters.map((favFilters, index)=>{
                if(favFilters.columnName=="main_date"){
                    //this.selectedDateFilter = {label: favFilters.filterValue,code: favFilters.filterValue};
                }else{
                    const selectedColumn = this.cols.find(col=>col.field==favFilters.columnName);

                    if(selectedColumn){
                        const filterGroup: IReportsFilterModel = {
                            id: index,
                            field: selectedColumn.field,
                            categoryId: selectedColumn.id,
                            category: selectedColumn.header,
                            nameId: selectedColumn.id+"",
                            notRemovable: false,
                            value: favFilters.filterValue,
                            previewValue: favFilters.filterValue,
                            dataType: selectedColumn.dataType
                        }

                        this.selectedFilterGroup.push(filterGroup);
                    }

                }
            });

            this.onApplyFilter(this.selectedWindow,this.selectedFilterGroup);
            this.appMainService.isHideSpinner('ReportFavFilters');
        }
    }

    //#region end

    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }


    getDifferenceInDays(date1, date2) {
        const diffInMs = Math.abs(date2 - date1);
        return diffInMs / (1000 * 60 * 60 * 24);
    }

    monthList(fromDate: Date, toDate: Date) {
        this.Months = [];
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ]

        var totalDayDiff = this.getDifferenceInDays(fromDate, toDate);
        var monthStart = fromDate.getMonth();
        var firstMonth = monthNames[monthStart];
        this.Months.push(firstMonth);
        var monthend = toDate.getMonth();

        if (monthStart != monthend) {
            for (var d = 28; totalDayDiff > d; d + 30) {

                var nextDate = new Date(fromDate.setDate(fromDate.getDate() + 28));
                var nextMonthNo = nextDate.getMonth();
                var nextMonth = monthNames[nextMonthNo];
                d = d + 28;
                this.Months.push(nextMonth)
            }
        }
        return this.Months;
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.onApplyFilter(selectedWindow, selectedFilters);
    }

    onClosePanel(selectedWindow: string): void {
        //this.DownloadReport(selectedWindow);
    }

    //when apply any filter
    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.reportsData = ParseHelper.DeepCopy(this.reportsDataCopy);

        if (selectedFilters?.length > 0) {
            switch (this.selectedWindow) {
                case ReportsOpportunityTypes.performancebysales:{
                    selectedFilters?.forEach(filt => {
                        if(filt.field=='accountName' || filt.field=='statusName'){
                            this.reportsData.map(data=>{
                                data.status = data.status.filter(x => x[filt.field] == filt.value);
                            });
                            this.reportsData = this.reportsData.filter(data=>data.status.length>0);
                        }else{
                            this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }

                        this.reportsData = this.formatSalesPerformanceData(this.reportsData);
                    })

                    break;
                }
                default:{
                    selectedFilters?.forEach(filt => {

                        let field: any = this.cols.find(f => f.field == filt.field);
                        if (field?.dataType == "date") {
                            this.reportsData = this.reportsData?.filter(x => {
                                const date = this.localDatePipe.transform(x[filt.field], 'date')
                                return date == filt.value;
                            }) ?? [];
                        }
                        else {
                            this.reportsData = this.reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                        }
                    });
                    break;
                }
            }
        }
        this.setFilterValues();
    }

    //when Edit applied filter
    onModifyFilterOptions(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        let reportsData: any[] = ParseHelper.DeepCopy(this.reportsDataCopy);

        switch (this.selectedWindow) {
            case ReportsOpportunityTypes.performancebysales:{
                selectedFilters?.forEach(filt => {
                    if(filt.field=='accountName' || filt.field=='statusName'){
                        reportsData.map(data=>{
                            data.status = data.status.filter(x => x[filt.field] == filt.value);
                        });
                        reportsData = reportsData.filter(data=>data.status.length>0);
                    }else{
                        reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                    }

                    reportsData = this.formatSalesPerformanceData(reportsData);
                })

                if(selectedFilters.length==0){
                    reportsData = this.formatSalesPerformanceData(reportsData);
                }

                this.filterByInputValue = [];
                reportsData.map(data=>{
                    data.status.map(status=>{
                        this.filterByInputValue.push({...data,...status});
                    });
                })

                break;
            }
            default:{
                selectedFilters?.forEach(filt => {

                    let field: any = this.cols.find(f => f.field == filt.field);
                    if (field?.dataType == "date") {
                        reportsData = reportsData?.filter(x => this.localDatePipe.transform(x[filt.field], 'date') == filt.value) ?? [];
                    }
                    else {
                        reportsData = reportsData?.filter(x => x[filt.field] == filt.value) ?? [];
                    }
                });

                this.filterByInputValue = [];
                this.filterByInputValue = [...reportsData];
                break;
            }
        }

    }


    //When date filter dropdown change
    onChangeRange(selectedWindow: string, event: { dateFrom: any, dateTo: any }): void {
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        this.OpportunityReport();
    }

    onOpportunityChangeChannel(selectedOpportunityChannel){
        this.selectedOpportunityChannel = selectedOpportunityChannel;
        this.OpportunityReport();
    }

    onChangeChannel(selectedChannel){
        this.selectedChannel = selectedChannel;
        this.OpportunityReport();
    }

    //#region Print, PDF, XLSX

    print() {
        this.appMainService.isShowSpinner('Print');
        this.exportPDF(this.selectedWindow, true);
        this.appMainService.isHideSpinner('Print');
    }

    exportPDF(selectedWindow: string, isPrintFlag = false) {
        this.PDFOpportunityReport(selectedWindow, isPrintFlag, "NoExcel");
    }

    exportXLS(selectedWindow: string) {
        this.PDFOpportunityReport(selectedWindow, false, "exportXLSX");
    }

    exportXLSX(selectedWindow: string) {
        this.PDFOpportunityReport(selectedWindow, false, "exportXLSX");
    }

    PDFOpportunityReport(selectedWindow: string, isPrintFlag: boolean, isexportXLS: string) {
        let dataResult = [];
        let modifiedData = [];
        let reportsData = ParseHelper.DeepCopy(this.reportsData);
        let groupColValue = '';

        if(this.selectedWindow==ReportsOpportunityTypes.performancebysales){
            reportsData.map((rowData, index) => {

                let cellStyle: CellDef = {
                    styles: {
                        fillColor: "#f1f1f1",
                        textColor: "#495057",
                        fontStyle: "bold"
                    },
                    content: ""
                }

                let cellStyleBold: CellDef = {
                    styles: {
                        fontStyle: "bold"
                    },
                    content: ""
                }

                // this.cols = [
                //     { id: 1, field: 'salesPerson', header: 'Sales Person', dataType: "string" },
                //     { id: 2, field: 'accountName', header: 'Account', dataType: "string" },
                //     { id: 3, field: 'statusName', header: 'Status', dataType: "string" },
                //     { id: 4, field: 'wonPerc', header: 'Won', dataType: "percentageSymbol" },
                //     { id: 5, field: 'lostPerc', header: 'Lost', dataType: "percentageSymbol" },
                //     { id: 6, field: 'totalOpen', header: 'Open', dataType: "string" },
                //     { id: 7, field: 'totalAll', header: 'Total', dataType: "string" },
                // ];

                let groupRow = {};
                let groupObj = {};

                this.tableCols.map(cols => {
                    groupObj[cols.header] = "";

                    if(cols.field=='salesPerson'){
                        groupRow[cols.field] = {
                            styles: {
                                fillColor: "#f1f1f1",
                                textColor: "#495057",
                                fontStyle: "bold"
                            },
                            colSpan: 3,
                            content: rowData[cols.field]
                        };

                        groupObj[cols.header] = rowData[cols.field];
                    }else if(cols.field=='wonPerc' || cols.field=='lostPerc'){
                        groupRow[cols.field] = ParseHelper.DeepCopy(cellStyle);
                        groupRow[cols.field].content = this.percentageSymbolPipe.transform(rowData[cols.field]) ?? rowData[cols.field];
                        groupObj[cols.header] = this.percentageSymbolPipe.transform(rowData[cols.field]) ?? rowData[cols.field];
                    }else if(cols.field=='totalOpen'){
                        groupRow[cols.field] = {
                            styles: {
                                fillColor: "#f1f1f1",
                                textColor: "#495057",
                                fontStyle: "bold"
                            },
                            colSpan: 2,
                            content: ""
                        };
                    }
                });

                if (groupObj) {
                    modifiedData.push(groupRow);
                    dataResult.push(groupObj);
                }

                rowData.status.map(statusData=>{
                    let obj = {};
                    let data = ParseHelper.DeepCopy(statusData);

                    this.tableCols.map(cols => {
                        if (cols.dataType == "datetime")
                            {
                                data[cols.field] = data[cols.field] ? this.localDatePipe.transform(data[cols.field]) : '';
                                obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                            }
                        else if (cols.dataType == "date")
                        {
                            data[cols.field] = data[cols.field] ? this.localDatePipe.transform(data[cols.field], 'date') : '';
                            obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                        }
                        else if (cols.dataType == 'number2dp') {
                            data[cols.field] = data[cols.field] ? parseFloat(data[cols.field])?.toFixed(2) ?? data[cols.field] : '';
                            obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                        }
                        else if (cols.dataType == 'currencySymbol') {
                            data[cols.field] = data[cols.field] ? this.currencySymbolPipe.transform(data[cols.field],'number2dp') ?? data[cols.field] :  '';
                            obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                        }
                        else if (cols.dataType == 'percentageSymbol') {
                            data[cols.field] = data[cols.field] ? this.percentageSymbolPipe.transform(data[cols.field]) ?? data[cols.field] : '';
                            obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                        }
                        else if (cols.dataType == "secsdhms")
                            {
                                data[cols.field] = data[cols.field] ? this.secsToDhmsPipe.transform(data[cols.field]) : '';
                                obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                            }
                        else
                            {
                                obj[cols.header] = data[cols.field] ? data[cols.field] : '';
                            }
                    });


                    if (obj) {
                        modifiedData.push(data);
                        dataResult.push(obj);
                    }
                })

                let groupSumRow = {};
                let groupSumObj = {};

                this.tableCols.map(cols => {
                    groupSumObj[cols.header] = "";

                    if(cols.field=='salesPerson'){
                        groupSumRow[cols.field] = ParseHelper.DeepCopy(cellStyleBold);
                        groupSumObj[cols.header] = "";
                    }else if(cols.field=='accountName'){
                        groupSumRow[cols.field] =  {
                            styles: {
                                fontStyle: "bold"
                            },
                            colSpan: 2,
                            content: "Sales Person Total:"
                        };
                        groupSumObj[cols.header] = "Sales Person Total:";
                    }else if(cols.field=='wonPerc'){
                        groupSumRow[cols.field] = ParseHelper.DeepCopy(cellStyleBold);
                        groupSumRow[cols.field].content = rowData['totalWon'];
                        groupSumObj[cols.header] = rowData['totalWon'];
                    }else if(cols.field=='lostPerc'){
                        groupSumRow[cols.field] = ParseHelper.DeepCopy(cellStyleBold);
                        groupSumRow[cols.field].content = rowData['totalLost'];
                        groupSumObj[cols.header] = rowData['totalLost'];
                    }else if(cols.field=='totalOpen'){
                        groupSumRow[cols.field] = ParseHelper.DeepCopy(cellStyleBold);
                        groupSumRow[cols.field].content = rowData['totalOpen'];
                        groupSumObj[cols.header] = rowData['totalOpen'];
                    }else if(cols.field=='totalAll'){
                        groupSumRow[cols.field] = ParseHelper.DeepCopy(cellStyleBold);
                        groupSumRow[cols.field].content = rowData['totalAll'];
                        groupSumObj[cols.header] = rowData['totalAll'];
                    }
                });

                if (groupSumObj) {
                    modifiedData.push(groupSumRow);
                    dataResult.push(groupSumObj);
                }


            })
        }else{
            reportsData.map((rowData, index) => {
                let obj = {};
                let groupObj = {};
                let data = ParseHelper.DeepCopy(rowData);
                let groupData = ParseHelper.DeepCopy(rowData);

                if(this.groupByFieldName){
                    if(index>0){groupColValue = reportsData[index-1][this.groupByFieldName]}
                    if(groupColValue!= rowData[this.groupByFieldName]){

                        let cellStyle: CellDef = {
                            styles: {
                                fillColor: "#f1f1f1",
                                textColor: "#495057",
                                fontStyle: "bold"
                            },
                            content: ""
                        }

                        this.tableCols.map(cols => {
                            if (cols.dataType == "datetime")
                                {
                                    groupData[cols.field] = cols.groupField ? this.localDatePipe.transform(groupData[cols.groupField]) : '';
                                    groupObj[cols.header] = groupData[cols.field];
                                }
                            else if (cols.dataType == 'date') {
                                groupData[cols.field] = cols.groupField ? this.localDatePipe.transform(groupData[cols.groupField], 'date') ?? groupData[cols.groupField] : "";
                                groupObj[cols.header] = groupData[cols.field];
                            }
                            else if (cols.dataType == 'number2dp') {
                                groupData[cols.field] = cols.groupField ? groupData[cols.groupField]?.toFixed(2) ?? groupData[cols.groupField] : "";
                                groupObj[cols.header] = groupData[cols.field];
                            }
                            else if (cols.dataType == 'currencySymbol') {
                                groupData[cols.field] = cols.groupField ? this.currencySymbolPipe.transform(groupData[cols.groupField],'number2dp') ?? groupData[cols.groupField] : "";
                                groupObj[cols.header] = groupData[cols.field];
                            }
                            else if (cols.dataType == 'percentageSymbol') {
                                groupData[cols.field] = cols.groupField ? this.percentageSymbolPipe.transform(groupData[cols.groupField]) ?? groupData[cols.groupField] : "";
                                groupObj[cols.header] = groupData[cols.field];
                            }
                            else if (cols.dataType == "secsdhms")
                                {
                                    groupData[cols.field] = cols.groupField ? this.secsToDhmsPipe.transform(groupData[cols.groupField]) : '';
                                    groupObj[cols.header] = groupData[cols.field];
                                }
                            else
                                {
                                    groupData[cols.field] = cols.groupField ? groupData[cols.groupField] : '';
                                    groupObj[cols.header] = groupData[cols.field];
                                }
                            cellStyle.content = groupData[cols.field];
                            groupData[cols.field] = ParseHelper.DeepCopy(cellStyle);
                        });

                        if (groupObj) {
                            modifiedData.push(groupData);
                            dataResult.push(groupObj);
                        }
                    }
                }


                this.tableCols.map(cols => {
                    if (cols.dataType == "datetime")
                        {
                            data[cols.field] = this.localDatePipe.transform(data[cols.field]);
                            obj[cols.header] = data[cols.field];
                        }
                    else if (cols.dataType == "date")
                    {
                        data[cols.field] = this.localDatePipe.transform(data[cols.field], 'date');
                        obj[cols.header] = data[cols.field];
                    }
                    else if (cols.dataType == 'number2dp') {
                        data[cols.field] =  parseFloat(data[cols.field])?.toFixed(2) ?? data[cols.field];
                        obj[cols.header] = data[cols.field];
                    }
                    else if (cols.dataType == 'currencySymbol') {
                        data[cols.field] =  this.currencySymbolPipe.transform(data[cols.field],'number2dp') ?? data[cols.field];
                        obj[cols.header] = data[cols.field];
                    }
                    else if (cols.dataType == 'percentageSymbol') {
                        data[cols.field] =  this.percentageSymbolPipe.transform(data[cols.field]) ?? data[cols.field];
                        obj[cols.header] = data[cols.field];
                    }
                    else if (cols.dataType == "secsdhms")
                        {
                            data[cols.field] = this.secsToDhmsPipe.transform(data[cols.field]);
                            obj[cols.header] = data[cols.field];
                        }
                    else
                        {
                            obj[cols.header] = data[cols.field];
                        }
                });


                if (obj) {
                    modifiedData.push(data);
                    dataResult.push(obj);
                }
            });
        }


        if (isexportXLS === "exportXLS" || isexportXLS === "exportXLSX") {

            if (isexportXLS === "exportXLSX") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
                    this.saveAsExcelFilexlsx(excelBuffer, this.reportName);
                });
            }

            if (isexportXLS === "exportXLS") {
                import("xlsx").then(xlsx => {
                    const worksheet = xlsx.utils.json_to_sheet(dataResult);
                    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
                    const excelBuffer: any = xlsx.write(workbook, { bookType: 'xls', type: 'array' });
                    this.saveAsExcelFilexls(excelBuffer, this.reportName);
                });
            }
        } else {
            let pdfcolumns = [];
            this.tableCols.map(cols => {
                pdfcolumns.push({ dataKey: cols.field, header: cols.header });
            })

            //Print/PDF
            ReportsPrintPdfService.openOrExportAsPDF(pdfcolumns, modifiedData, this.organizationName, this.dateFrom, this.dateTo, this.reportName, null, null, isPrintFlag);
            this.noContactFindOrLoadingText = 'No Reports Available.';
        }
    }
    saveAsExcelFilexls(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xls';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
    saveAsExcelFilexlsx(buffer: any, fileName: string): void {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }

    private saveAsPdfFile(buffer: any, fileName: string): void {
        buffer.save(fileName + '.pdf');
    }

    //#endregion

    //#chartRegion

    groupByData(xs, key) {
        const groupList = [];
        const group = xs.reduce(function(rv, x) {
          (rv[x[key]] = rv[x[key]] || []).push(x);
          return rv;
        }, {});

        Object.keys(group).map(k=>{
            let obj = {};
            obj[key] = k;
            obj['dataList'] = group[k];

            groupList.push(obj);
        });

        return groupList;
    };

    setClosedWonChart(){
        const stackBar = {
            labels: [],
            owners: [],
            datasets: []
        };
        this.stackedBarByClosedWon = stackBar;

        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        const classNamees = this.groupByData(this.reportsData,'className');
        const owners = this.groupByData(this.reportsData,'opportunityOwner');

        owners.filter(data=> data.opportunityOwner!='null' && data.opportunityOwner).map(owner=>{
            const totalWon = owner.dataList?.length>0 ? owner.dataList.reduce((sum, data) => data.closedWonAmount + sum, 0) : 0;
            stackBar.labels.push(`${owner.opportunityOwner.trim()} (${this.currencySymbolPipe.transform(totalWon,'number2dp')})`);
            stackBar.owners.push(owner.opportunityOwner);
        });

        // const randomColors = this.randColor(owners.length);
        // console.log(randomColors);

        classNamees.filter(data=> data.className!='null' && data.className).map((className, index)=>{
            const stackData = {
                type: 'bar',
                label: className.className,
                backgroundColor: className.dataList[0].classcolor ?? this.getColor(index),
                data: []
            }

            stackBar.owners.map(owner=>{
                const dataByStage = className.dataList.filter(data=> data.opportunityOwner === owner);
                const closedWonAmount = dataByStage ? dataByStage.reduce((sum, data) => data.closedWonAmount + sum, 0) : 0;
                stackData.data.push(closedWonAmount);
            });


            stackBar.datasets.push(stackData);
        });

        this.stackedBarByClosedWon = stackBar;
    }

    setClosedWonCountChart(){
        const stackBar = {
            labels: [],
            owners: [],
            datasets: []
        };
        this.stackedBarByClosedWonCount = stackBar;

        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        const classNamees = this.groupByData(this.reportsData,'className');
        const owners = this.groupByData(this.reportsData,'opportunityOwner');

        owners.filter(data=> data.opportunityOwner!='null' && data.opportunityOwner).map(owner=>{
            const totalWonCount = owner.dataList?.length||0;
            stackBar.labels.push(`${owner.opportunityOwner.trim()} (${totalWonCount})`);
            stackBar.owners.push(owner.opportunityOwner);
        });

        // const randomColors = this.randColor(owners.length);
        // console.log(randomColors);

        classNamees.filter(data=> data.className!='null' && data.className).map((className, index)=>{
            const stackData = {
                type: 'bar',
                label: className.className,
                backgroundColor: className.dataList[0].classcolor ?? this.getColor(index),
                data: []
            }

            stackBar.owners.map(owner=>{
                const dataByStage = className.dataList.filter(data=> data.opportunityOwner === owner);
                const closedWonCount = dataByStage?.length||0;
                stackData.data.push(closedWonCount);
            });


            stackBar.datasets.push(stackData);
        });

        this.stackedBarByClosedWonCount = stackBar;
    }

    setStageSummeryChart(){
       const stageChart = {
            labels: [],
            datasets: [
                {
                    label: 'Opportunity Stage',
                    backgroundColor: '#42A5F5',
                    data: []
                },
            ]
        }
        this.stageSummeryBar = stageChart;
        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        this.reportsData.map(stageDetails=>{
            stageChart.labels.push(stageDetails.opportunityStage);
            //stageChart.datasets[0].backgroundColor = stageDetails.stageColor ?? '#42A5F5';
            stageChart.datasets[0].data.push(stageDetails.grandTotal);
        });
        this.stageSummeryBar = stageChart;
    }

    setStageDetailsChart(){
        const stackBar = {
            labels: [],
            datasets: []
        };
        this.stageDetailsBar = stackBar;

        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        const stages = this.groupByData(this.reportsData,'opportunityStage');
        const owners = this.groupByData(this.reportsData,'opportunityOwner');

        stages.map(stage=>{
            stackBar.labels.push(stage.opportunityStage);
        });

        // const randomColors = this.randColor(owners.length);
        // console.log(randomColors);

        owners.filter(data=> data.opportunityOwner!='null' && data.opportunityOwner).map((owner, index)=>{
            const stackData = {
                type: 'bar',
                label: owner.opportunityOwner,
                backgroundColor: this.getColor(index),
                data: []
            }

            stackBar.labels.map(stage=>{
                const dataByStage = owner.dataList.filter(data=> data.opportunityStage === stage);
                const totalStageAmount = dataByStage ? dataByStage.reduce((sum, data) => data.totalAmount + sum, 0) : 0;
                stackData.data.push(totalStageAmount);
            });


            stackBar.datasets.push(stackData);
        });

        this.stageDetailsBar = stackBar;
    }

    setPerformanceCharts(){
        let stackedBar1 = {
            labels: [],
            datasets: [{
                type: 'bar',
                label: 'Won',
                backgroundColor: '#66BB6A',
                data: []
            }, {
                type: 'bar',
                label: 'Lost',
                backgroundColor: '#df3f2a',
                data: []
            }]
        };
        this.performanceStackBarAmount = stackedBar1;
        let stackedBar2 = {
            labels: [],
            datasets: [{
                type: 'bar',
                label: 'Won',
                backgroundColor: '#66BB6A',
                data: []
            }, {
                type: 'bar',
                label: 'Lost',
                backgroundColor: '#df3f2a',
                data: []
            }]
        };
        this.performanceStackBarPercentage = stackedBar2;

        if (!this.reportsData || !this.reportsData.length) {
            return;
        }

        this.reportsData.map(wonLostDetails=>{
            stackedBar1.labels.push(wonLostDetails.salesPerson);
            stackedBar1.datasets[0].data.push(wonLostDetails.totalWonAmount);
            stackedBar1.datasets[1].data.push(wonLostDetails.totalLostAmount);

            stackedBar2.labels.push(wonLostDetails.salesPerson);
            stackedBar2.datasets[0].data.push(wonLostDetails.wonPerc);
            stackedBar2.datasets[1].data.push(wonLostDetails.lostPerc);

        });

        this.performanceStackBarAmount = stackedBar1;
        this.performanceStackBarPercentage = stackedBar2;
    }

    getColor(index){

        const colorList = ['#42A5F5','#66BB6A','#FFA726','#7E57C2','#26A69A',"#FF6384","#36A2EB"];

        if(index>6){
            let i = index%6;
            return colorList[i];
        }else{
            return colorList[index];
        }
    }

    randColor(numColors) {
        const chars = "ABCDEF0123456789";
        const size = chars.length;
        let str = [];

        for(let i = 0; i < numColors; i++ ) {
            str[i] = "#";
            for(let j = 0; j < 6; j++ ) {
                const rand = Math.floor(Math.random() * (size - 1)) + 1;
                str[i] += chars[rand];
            }
        }
        return str;
    }
    //#endChartRegion

    closeFilterPopup(){
        this.displayFilterPopup = false;
        this.onCloseFilterPopup.emit(false);
    }

    setAddedFilters(){
        const addedDateRange = DATE_RANGE_LIST.find(range=>range.code==this.selectedReportFilters.dateFilter);
        const filterValues: ReportsAllFiltersAppyModels = {
            applyMode: ReportsAllFiltersApplyModes.applyOnly,
            dateFilter: {
                ...addedDateRange,
                fromDate: this.dateFrom,
                toDate: this.dateTo
            },
            opportunityChannel: this.selectedOpportunityChannel,
            accountChannel: this.selectedChannel
        }

        this.onUpdateAllFilters.emit(filterValues);
    }

    allFiltersChanges(filterValues: ReportsAllFiltersAppyModels){
        this.reportsFilterApplyMode = filterValues.applyMode;
        this.dateFrom = filterValues?.dateFilter?.fromDate || this.dateFrom;
        this.dateTo = filterValues?.dateFilter?.toDate || this.dateTo;
        this.selectedOpportunityChannel = filterValues?.opportunityChannel || this.selectedOpportunityChannel;
        this.selectedChannel = filterValues?.channel || this.selectedChannel;
        filterValues.accountChannel =  this.selectedChannel;
        this.OpportunityReport();

        this.onUpdateAllFilters.emit(filterValues)
    }


}
